import React from 'react';
import { Skeleton } from 'primereact/skeleton';

export default function NextPaymentPlaceholder() {
  return (
    <div className="card-bg mb-3 p-3 d-flex flex-column">
      <Skeleton width="40%" borderRadius="5px" className="mb-1" />
      <Skeleton width="40%" borderRadius="5px" className="mb-1" />
      <Skeleton width="40%" borderRadius="5px" className="mb-1" />
      <Skeleton width="40%" borderRadius="5px" className="mb-1" />
    </div>
  );
}
